module.exports = __webpack_public_path__ + "static/media/icon_add_to_plan.f959d6c6.svg";